import React from 'react';
import RedesignHeader from './RedesignHeader';
import RedesignFooter from './RedesignFooter';
import CustomCursor from '../ui/CustomCursor';

const Layout = ({ children }) => {
  return (
    <>
      <CustomCursor />
      <a href="#home" className="skip-to-content">
        Skip to content
      </a>
      <RedesignHeader />
      <main id="main-content">
        {children}
      </main>
      <RedesignFooter />
    </>
  );
};

export default Layout;